/**
 * @Author: v_jppjpeng
 * @Date: 2025-02-07 10:17:38
 * @Explain: ab测试
 */

export default {
  // 旧版 活动管理 - 创建ab测试
  'ACTIVITY.AB.TEST.FROM.TIPS': 'Set the sender details for this test',
  'ACTIVITY.AB.TEST.TO.TIPS': 'Select the recipients for this campaign',
  'ACTIVITY.AB.TEST.PLEASE.ENTER.PROPORTION': 'Please enter proportion',
  'ACTIVITY.AB.TEST.TWO.DECIMAL.PLACES': 'Keep 2 decimal places',
  'ACTIVITY.AB.TEST.GREATER.THAN.0': 'Be greater than 0',
  'ACTIVITY.AB.TEST.SUM.100': 'The sum equals 100',

  // 旧版 活动管理 - 创建ab测试 - 实验设置
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING': 'Setup',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SUBJECT': 'Subject variations',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.TIPS':
    'Configure variables and group sizes',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.MIN.TIPS':
    'Minimum number of test groups: {num}',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.MAX.TIPS':
    'Maximum number of test groups: {num}',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SELECTED':
    '<b>{num}</b> variations have been configured',
  'ACTIVITY.MANAGE.EXPERIMENT.VARIABLES': 'Variables',
  'ACTIVITY.MANAGE.EXPERIMENT.GROUP.PROPORTION': 'Group sizes',
  'ACTIVITY.MANAGE.EXPERIMENT.PLEASE.ENTER.GROUP.PROPORTION':
    'Please enter group sizes',
  'ACTIVITY.MANAGE.EXPERIMENT.ORDER': 'Setup {num}',
  'ACTIVITY.MANAGE.EXPERIMENT.SUBJECT.PLACEHOLDER': 'Enter subject line {num}',
  'ACTIVITY.MANAGE.EXPERIMENT.CONFIGURED.SUBJECT': '{num} variations',
  'ACTIVITY.MANAGE.EXPERIMENT.NOT.CONFIGURED.SUBJECT': 'Not configured',
  'ACTIVITY.MANAGE.EXPERIMENT.NOT.CONFIGURED.SUBJECT.TIPS':
    'This test setup does not include a subject line or preview text. These recipients will be shown the subject line and preview text from the default language.',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SUBJECT.PREVIEW.TEXT':
    'Subject line & Preview text',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.TITLE': 'Warning',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.DESC1':
    'Group size is smaller than {maxNum} recipients. Your A/B test might not derive statistically significant results.',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.DESC2':
    "It's recommended to adjust the number of recipients, number of groups, or group sizes.",
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.BACK.EDIT': 'Modify',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.CONFIRM.SET': 'Confirm',

  // 活动管理 - ab测试 - 列表
  // 'ACTIVITY.AB.TEST.LIST.ALL.TEST': 'A/B test',
  'ACTIVITY.AB.TEST.LIST.CARD.TITLE': 'Tests list',
  'ACTIVITY.AB.TEST.LIST.SEARCH.TAG.PLACEHOLDER': 'Search test',
  'ACTIVITY.AB.TEST.LIST.CREATE.TEST': 'Create test',
  'ACTIVITY.AB.TEST.LIST.CREATE.TEST.NAME': 'Test name',
  'ACTIVITY.AB.TEST.LIST.CREATE.ENTER.TEST.NAME': 'Enter test name',
  'ACTIVITY.AB.TEST.LIST.TEST.NAME.EXIST': 'Test name entered already exists',
  'ACTIVITY.AB.TEST.LIST.CREATE.DESC1':
    'Create and publish tests. Configure the sample population, test variables and test emails within a few minutes.',

  'ACTIVITY.AB.TEST.LIST.UNPUBLISHED.NOTES':
    'The test is incomplete and in a temporary state. After editing,it can be directly published or applied for publication.',
  'ACTIVITY.AB.TEST.LIST.UNDER.APPROVAL.NOTES':
    'The test has been applied for release and is awaiting approval.',
  'ACTIVITY.AB.TEST.LIST.HAVE.IN.HAND.NOTES':
    'The campaign is successfully published and has entered active delivery phase upon reaching scheduled time‌.',
  'ACTIVITY.AB.TEST.LIST.SUSPENDED.NOTES':
    'Campaign has been paused manually and is currently not delivering emails.',

  'ACTIVITY.AB.TEST.LIST.TEST.DETAILS': 'Test details',
  'ACTIVITY.AB.TEST.DELETE.DIALOG.HEADER':
    'Are you sure you want to delete this test?',
  'ACTIVITY.AB.TEST.DELETE.DIALOG.CONTENT':
    'Delete task "{name}", and the task will no longer be available for use',
  'ACTIVITY.AB.TEST.BATCH.DELETE.DIALOG.HEADER': 'Are you sure to delete?',

  // 活动管理 - 创建ab测试 - 收件人
  'ACTIVITY.AB.TEST.RECIPIENTS': 'Recipients',

  // 活动管理 - 创建ab测试 - 测试设置
  'ACTIVITY.AB.TEST.SETUP': 'Setup',
  'ACTIVITY.AB.TEST.SETUP.SUB.TITLE':
    'Configure test phase group size and winning criteria',

  // 测试分流比
  'ACTIVITY.AB.TEST.SPLIT.RATIO.TITLE':
    'Percentage of contacts in the test group',

  // 你要测试主题和预览文本的数量
  'ACTIVITY.AB.TEST.EXPERIMENTAL.GROUP.TITLE': 'Number of variations',

  // 获胜标准
  'ACTIVITY.AB.TEST.WINNING.SELECTION.RULE.TITLE': 'Winner criteria',
  'ACTIVITY.AB.TEST.WINNING.SELECTION.RULE.TIPS':
    'The winner is decided based on the open rate at {num} after the test phase has finished delivering emails. The winner is fixed and will not change afterwards, regardless of any changes to the test phase results.',

  'ACTIVITY.AB.TEST.SELECT.MANUALLY.TIPS':
    'After the test phase has finished, you can manually select the winner in the campaign report. If there is no winner selected manually for 3 days after the test phase has finished, the variation with the highest open rate will be automatically selected as the winner.',

  'ACTIVITY.AB.TEST.WINNING.CRITERIA': 'Winner criteria',
  'ACTIVITY.AB.TEST.SELECT.MANUALLY': 'Select manually',
  'ACTIVITY.AB.TEST.BY.OPEN.RATE': 'By open rate',
  'ACTIVITY.AB.TEST.WAIT.TIME': 'Wait time',
  'ACTIVITY.AB.TEST.WAIT.TIME.TIPS':
    'Wait time after test phase emails have been delivered',
  'ACTIVITY.AB.TEST.WAIT.TIME.PLACEHOLDER': 'Please enter the wait time',
  'ACTIVITY.AB.TEST.WAIT.TIME.REG': 'Please enter an integer between 1 and 99',
  'ACTIVITY.AB.TEST.HOURS': 'Hour(s)',
  'ACTIVITY.AB.TEST.DAYS': 'Day(s)',
  'ACTIVITY.AB.TEST.WAIT.TIME.WARNING':
    'It is recommended to wait at least <b>{ num }</b> to allow collecting results.',

  // 想要按地区或语言分别确认获胜组？
  'ACTIVITY.AB.TEST.WINNING.GROUP.BY.LANG.OR.REGION':
    'Click here to test variations in different languages',
  'ACTIVITY.AB.TEST.DIVIDED.SETTING.TITLE': 'Winner selection',
  'ACTIVITY.AB.TEST.DIVIDED.SETTING.DESC':
    'Select a single winner for all audiences or a different winner for each audience. The winner will be delivered automatically to the remaining audience.',
  'ACTIVITY.AB.TEST.DISABLED': 'Different winner',
  'ACTIVITY.AB.TEST.DIVIDED.BY.LANGUAGE': 'Single winner',
  'ACTIVITY.AB.TEST.DIVIDED.BY.LOCATION': 'Split by location',
  'ACTIVITY.AB.TEST.ORGANISE.LANGUAGE': 'Combine languages',
  'ACTIVITY.AB.TEST.MERGE.LANGUAGE.DESC':
    "The following languages are grouped under <b class='color-333'>'Others'</b> to ensure each variation is sent to an acceptable group size.",

  // 测试设置 - 总结
  'ACTIVITY.AB.TEST.SUMMARY.TITLE': 'Overview',
  'ACTIVITY.AB.TEST.TOTAL.RECIPIENTS': 'Total',
  'ACTIVITY.AB.TEST.RECIPIENTS.FOR.TEST': 'Test phase',
  'ACTIVITY.AB.TEST.RECIPIENTS.TEST': 'Recipients in test phase',
  'ACTIVITY.AB.TEST.RECIPIENTS.PER.SETUP': 'Group size',
  'ACTIVITY.AB.TEST.LANGUAGE.DIVIDED.TITLE': 'Language group sizes',
  'ACTIVITY.AB.TEST.LANGUAGE.DIVIDED.TIPS':
    'The winner is decided independently for each language, so that each language will use the best performing variation.',
  'ACTIVITY.AB.TEST.MIN.RECIPIENT.TIPS':
    'It is recommended to have at least {num} recipients in each test group.',
  'ACTIVITY.AB.TEST.SUMMARY.FORECAST.TIPS':
    'Overview data is estimated based on current conditions',

  // 活动管理 - 创建ab测试 - 设置主题、预览文本
  'ACTIVITY.AB.TEST.VARIABLES': 'Variations',
  'ACTIVITY.AB.TEST.VARIABLES.SUB.TITLE': 'Configure variables',

  // 活动管理 - 创建ab测试 - 配置活动信息
  'ACTIVITY.AB.TEST.BASE.INFO.TITLE': 'Content',
  'ACTIVITY.AB.TEST.BASE.INFO.SUB.TITLE':
    'Configure content for each variation',

  // 活动管理 - 创建ab测试 - 详情总结
  'ACTIVITY.AB.TEST.DETAILS.REVIEW.CONFIRM': 'Review',
  'ACTIVITY.AB.TEST.DETAILS.REVIEW.CONFIRM.TITLE': 'Review',
  'ACTIVITY.AB.TEST.DETAILS.RECIPIENTS': 'Recipients',
  'ACTIVITY.AB.TEST.DETAILS.SETUP.DIVIDED.SETTING': 'Audience split',
  'ACTIVITY.AB.TEST.DETAILS.TEST.SPLIT.RATIO': 'Test group (ratio & size)',
  'ACTIVITY.AB.TEST.DETAILS.WINNING.CRITERIA': 'Winner criteria',
  'ACTIVITY.AB.TEST.DETAILS.WAIT.NUM': 'After {num} ',
  'ACTIVITY.AB.TEST.DETAILS.NUMBER.OF.SETUP': 'Variations (count & size)',
  'ACTIVITY.AB.TEST.DETAILS.SEND.TIME': 'Delivery time',
  'ACTIVITY.AB.TEST.SUMMARY.DETAILS.TIPS1':
    'Winner was manually selected on <b>{time}</b>, ',
  'ACTIVITY.AB.TEST.SUMMARY.SEE.DETAILS': 'see details',

  // 按钮
  'ACTIVITY.AB.TEST.SEND.TEST.EMAIL': 'Send test email',
  'ACTIVITY.AB.TEST.SEND.TEST.EMAIL.TIPS':
    'Please complete all necessary steps',
  'ACTIVITY.AB.TEST.SAVE.DRAFT': 'Save as draft',
  'ACTIVITY.AB.TEST.NEXT': 'Continue',
  'ACTIVITY.AB.TEST.SUBMIT.FOR.APPROVAL': 'Submit for approval',
};
